/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Tier_Pro_LabelInputs */

const en_agb_tier_pro_label = /** @type {(inputs: Agb_Tier_Pro_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro (EUR 34.99/month, EUR 24.99/month billed annually): `)
};

const de_agb_tier_pro_label = /** @type {(inputs: Agb_Tier_Pro_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro (EUR 34,99/Monat, EUR 24,99/Monat bei jaehrlicher Abrechnung): `)
};

const fr_agb_tier_pro_label = /** @type {(inputs: Agb_Tier_Pro_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro (EUR 34,99/mois, EUR 24,99/mois facturé annuellement) : `)
};

const es_agb_tier_pro_label = /** @type {(inputs: Agb_Tier_Pro_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro (EUR 34,99/mes, EUR 24,99/mes facturado anualmente): `)
};

const it_agb_tier_pro_label = /** @type {(inputs: Agb_Tier_Pro_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro (EUR 34,99/mese, EUR 24,99/mese fatturato annualmente): `)
};

const nl_agb_tier_pro_label = /** @type {(inputs: Agb_Tier_Pro_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro (EUR 34,99/maand, EUR 24,99/maand bij jaarlijkse facturering): `)
};

const pl_agb_tier_pro_label = /** @type {(inputs: Agb_Tier_Pro_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro (EUR 34,99/mies., EUR 24,99/mies. przy rozliczeniu rocznym): `)
};

const fi_agb_tier_pro_label = /** @type {(inputs: Agb_Tier_Pro_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro (EUR 34,99/kk, EUR 24,99/kk vuosilaskutuksella): `)
};

const da_agb_tier_pro_label = /** @type {(inputs: Agb_Tier_Pro_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro (EUR 34,99/måned, EUR 24,99/måned ved årlig fakturering): `)
};

const sv_agb_tier_pro_label = /** @type {(inputs: Agb_Tier_Pro_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro (EUR 34,99/månad, EUR 24,99/månad vid årsfakturering): `)
};

/**
* | output |
* | --- |
* | "Pro (EUR 34.99/month, EUR 24.99/month billed annually):" |
*
* @param {Agb_Tier_Pro_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_tier_pro_label = /** @type {((inputs?: Agb_Tier_Pro_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Tier_Pro_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_tier_pro_label(inputs)
	if (locale === "fr") return fr_agb_tier_pro_label(inputs)
	if (locale === "es") return es_agb_tier_pro_label(inputs)
	if (locale === "it") return it_agb_tier_pro_label(inputs)
	if (locale === "nl") return nl_agb_tier_pro_label(inputs)
	if (locale === "pl") return pl_agb_tier_pro_label(inputs)
	if (locale === "fi") return fi_agb_tier_pro_label(inputs)
	if (locale === "da") return da_agb_tier_pro_label(inputs)
	if (locale === "sv") return sv_agb_tier_pro_label(inputs)
	return en_agb_tier_pro_label(inputs)
});